import Phaser from 'phaser'
import { PLINKO_ATLAS_FRAMES, PLINKO_TEXTURE_KEYS } from './constants'
import { Foreground } from '../base/foreground'

export class PlinkoForeground extends Foreground {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createForeground() {
    const foreground = this.scene.add.image(
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY + 10,
      PLINKO_TEXTURE_KEYS.ATLAS,
      PLINKO_ATLAS_FRAMES.FOREGROUND,
    )
    foreground.setOrigin(0.5, 0.5)

    this.add(foreground)
  }
}
